import React, { useState, useEffect, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import {
    message
} from 'antd';
import { receiptRulesPlanMainPageList } from '@/services/fmsConfig'
import { chooseChangePlanMain } from '@/services/fmsServices'
import dayjs from 'dayjs'
import { SLowcodeList } from 'shj-components'
export function SelectPlanFn({ fns, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };

    const dialog = SFuncModal({
        title: `选择变更后收款计划`,
        width: 1000,
        vanish: true,
        content: <SelectPlanDom onClose={onClose} fns={fns} {...rest} />,
    });

    return dialog;
}
const SelectPlanDom = ({ onClose, fns, ...rest }) => {
    const listRef = useRef<any>();
    const [loading, setLoading] = useState(false);
    const config = {
        rowSelectionType: 'radio',
        columns: [
            {
                title: '收款计划名称', dataIndex: 'name', width: 200, ellipsis: true
            },
            {
                title: '描述', dataIndex: 'remarks', width: 200, ellipsis: true
            },
            {
                title: '是否默认', dataIndex: 'isDefault', width: 120, render: (text) => {
                    return text ? '是' : '否';
                }
            },
            {
                title: '创建日期', dataIndex: 'createdTime', width: 140, render: (text) => {
                    return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
                }
            },
        ],
        search: [{
            name: "name",
            label: "计划名称",
            addonOpts: ["=", "∈"]
        },],
        batchActions: [
            {
                label: '变更',
                type: 'primary',
                loading: loading,
                disabled: 'onDisabled',
                events: ['onClick:tableChange'],
            }
        ]
    };
    const tableChange = ({selectedRows}) => {
        setLoading(true)
        chooseChangePlanMain({orderId: rest.orderId,payMainId: selectedRows[0].id}).then(res=>{
            setLoading(false)
            onClose();
            fns && fns();
            message.success('变更成功')
        }).catch(err=>{
            setLoading(false)
        })
    };
    // 表格加载
    const fetchList = (values: any) => {
        const { current, pageSize, ...rest } = values;
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query } = values
                query.enabled = 1
                let data = await receiptRulesPlanMainPageList(current, pageSize, query);
                const { records, total } = data;
                resolve({ records, total });
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    // 右侧表格配置
    const extension = {
        request: { fetchList },
        events: { tableChange },
        status: {
            onDisabled: ({ selectedRowKeys }: Record<string, number[]>) => selectedRowKeys.length < 1,
        },
        customRender: {},
    }
    return (
        <div style={{ padding: '20px' }}>
            <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
        </div>
    );
};
